import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../../hooks/useStore';
import { DataViewEditBox, useForm } from '../../../../../lib/components';
import { PaymentDataForm } from './form';
import { PaymentDataView } from './view';

export const CompanyPaymentData = observer(() => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const paymentData = {
    pricing_model: companyStore.paymentData?.pricing_model,
    payment_interval: companyStore.paymentData?.payment_interval,
    monthly_price_per_employee: companyStore.paymentData?.monthly_price_per_employee || 0,
    vat_id: companyStore.paymentData?.vat_id || '',
    contact_first_name: companyStore.paymentData?.contact_first_name || '',
    contact_last_name: companyStore.paymentData?.contact_last_name || '',
    invoice_email: companyStore.paymentData?.invoice_email || '',
    mandate_email: companyStore.paymentData?.mandate_email || ''
  };
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const form = useForm();

  const renderView = observer(() => <PaymentDataView data={paymentData} />);

  const renderEdit = () => {
    return (
      <PaymentDataForm
        initialValues={paymentData}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            await companyStore.updatePaymentData(values);
          } catch (error) {
            console.error(error);
          }
        }}
        useCustomButton
      />
    );
  };

  useEffect(() => {
    const abortController = new AbortController();
    const fetch = async () => {
      try {
        await companyStore.fetchPaymentData();
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };
    fetch();

    return () => abortController.abort();
  }, [companyStore.company]);

  return (
    <DataViewEditBox
      title={t('company:PAYMENT')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
